import React from 'react';
import * as R from 'ramda';
// helpers/constants
import * as G from '../helpers';
import * as GC from '../constants';
// ui
import { Flex, Box, StickedBox, MainActionButton } from '../ui';
//////////////////////////////////////////////////

const colorsMap = {
  [GC.NOTIFICATION_WARNING_LEVEL_TYPE_INFO]: 'colors.bgLightBlue',
  [GC.NOTIFICATION_WARNING_LEVEL_TYPE_CRITICAL]: 'colors.light.lightPink',
  [GC.NOTIFICATION_WARNING_LEVEL_TYPE_WARNING]: 'colors.light.warningBackground',
};

const textStyles = {
  px: 10,
  wordBreak: 'break-all',
};

const bgColor = G.getTheme('colors.#F8FAFD');
const mainDarkColor = G.getTheme('colors.dark.mainDark');

const IssueItem = ({ type, warningLevel, expirationDate, issueObjectName, issueObjectNames }) => (
  <Flex p='15px 5px' width='100%' bg={bgColor} fontSize={12} borderRadius={15}>
    <Flex
      mr={15}
      py='3px'
      width={90}
      fontSize={13}
      borderRadius={10}
      color={mainDarkColor}
      justifyContent='center'
      bg={G.getTheme(R.propOr('colors.white', warningLevel, colorsMap))}
    >
      {G.getEnumLocale(warningLevel)}
    </Flex>
    <Box {...textStyles} width={110}>{expirationDate}</Box>
    <Box {...textStyles} width={150}>{G.getEnumLocale(type)}</Box>
    <Box {...textStyles} width={200}>
      {
        G.isNotNilAndNotEmpty(issueObjectNames)
          ? R.join(', ', issueObjectNames)
          : issueObjectName
      }
    </Box>
  </Flex>
);

const IssueList = ({ issues, handleHideIssues }) => (
  <Flex
    px='3px'
    bg='white'
    width='100%'
    maxHeight={500}
    overflowY='auto'
    borderRadius={15}
    height='max-content'
    flexDirection='column'
    alignItems='flex-start'
  >
    <StickedBox
      top='0px'
      width='100%'
      flexDirection='column'
      bg={G.getTheme('colors.white')}
      borderRadius='0px 0px 15px 15px'
    >
      <MainActionButton
        height='auto'
        display='block'
        fontWeight={600}
        borderRadius={10}
        border='1px solid'
        m='8px 10px 8px auto'
        color={mainDarkColor}
        onClick={() => handleHideIssues(issues)}
        borderColor={G.getTheme('colors.borderGray')}
      >
        {`${G.getWindowLocale('actions:hide', 'Hide')} ${G.getWindowLocale('titles:notifications', 'Notifications')}`}
      </MainActionButton>
      <Flex
        py={16}
        fontSize={12}
        fontWeight='bold'
        borderRadius={15}
        color={mainDarkColor}
        bg={G.getTheme('colors.light.lightGrey')}
      >
        <Box px={10} width={110}>{G.getWindowLocale('titles:warning-level', 'Warning Level')}</Box>
        <Box px={10} width={110}>{G.getWindowLocale('titles:expiration-date', 'Expiration Date')}</Box>
        <Box px={10} width={150}>{G.getWindowLocale('titles:issue-type', 'Issue Type')}</Box>
        <Box px={10} width={200}>{G.getWindowLocale('titles:issue-object-name', 'Issue Object Name')}</Box>
      </Flex>
    </StickedBox>
    <Flex py='3px' gap='3px' flexDirection='column'>
      {issues.map((issue, index) => <IssueItem key={index} {...issue} />)}
    </Flex>
  </Flex>
);

export default IssueList;
